export const STRIPE_WAIT_EXPLANATION_KEY = 'wait-explanation';

export enum ECommonMessages {
  PreviousRequestExecuting = 'The previous request is being executed'
}
